import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateLibraryTypeModal } from "./components/CreateLibraryTypeModal";

export const CreateLibraryTypePage = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (!open) {
      // Navigate back when modal is closed
      navigate(-1);
    }
  };

  const handleSuccess = (fieldGroupId: string) => {
    // Navigate to the new library
    navigate(`/audit/libraries/${fieldGroupId}`);
  };

  return (
    <CreateLibraryTypeModal
      open={isOpen}
      onOpenChange={handleOpenChange}
      onSuccess={handleSuccess}
    />
  );
};
